const user = {
  firstName: "Sarah",
  lastName: "Ellen",
};

export default user;
